<script lang="ts">
    import { onMount } from "svelte";
    import Navbar from "../materialize/components/Navbar.svelte";
    import { link } from "svelte-spa-router";
    import Divider from "../materialize/grid/Divider.svelte";
    import {auth_token} from "../stores/stores";
    import active from 'svelte-spa-router/active'



    let sidemenu: HTMLElement;
    onMount(() => {
        M.Sidenav.init(sidemenu, {});
    });

    function close() {
        M.Sidenav.getInstance(sidemenu).close();
    }
</script>

<div class="navbar-fixed">
    <nav>
        <div class="nav-wrapper">
            <a data-target="mobile-demo" class="sidenav-trigger">
                <i class="material-icons">menu</i>
            </a>
            <ul class="right hide-on-med-and-down">
                <li use:active={{path: '/\/|\/search\/*|\/ricerca\/*/', className: 'active'}} ><a on:click={close} href="/" use:link>Cerca</a></li>
                <li use:active={{path: '/tutorial', className: 'active'}}><a on:click={close} href="/tutorial" use:link>Scrivere in dialetto</a></li>
                <li use:active={{path: '/contribute*', className: 'active'}}><a on:click={close} href="/contribute/audio" use:link>Contribuisci</a></li>
            </ul>
        </div>
    </nav>
</div>
<ul bind:this={sidemenu} class="sidenav" id="mobile-demo">
    <li use:active={{path: '/\/|\/search\/*|\/ricerca\/*/', className: 'active'}} ><a on:click={close} href="/" use:link>Cerca</a></li>
    <li use:active={{path: '/tutorial', className: 'active'}}><a on:click={close} href="/tutorial" use:link>Scrivere in dialetto</a></li>
    <li use:active={{path: '/contribute*', className: 'active'}}><a on:click={close} href="/contribute/audio" use:link>Contribuisci</a></li>
</ul>
